module.exports = __webpack_public_path__ + "static/media/website.0b38fa66.png";